function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowserWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E5E5E5"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.92,
    y: 456,
    style: {
      fill: "#CCCCCC"
    },
    width: 176,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ADADAD"
    },
    points: "311.96,455.96 199.96,455.96 207.96,399.96 303.96,399.96 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M447.96,359.96v32c0,4.4-3.6,8-8,8h-368c-4.4,0-8-3.6-8-8v-32H447.96z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0",
    x: 80,
    y: 120,
    style: {
      fill: "#FFFFFF"
    },
    width: 352,
    height: 224
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B3B3B"
    },
    d: "M439.96,103.96h-368c-4.4,0-8,3.6-8,8v248h384v-248C447.96,107.56,444.36,103.96,439.96,103.96z  M431.952,343.96h-352v-224h352V343.96z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0_1_",
    x: 80,
    y: 120,
    style: {
      fill: "#FFFFFF"
    },
    width: 352,
    height: 224
  })), /*#__PURE__*/React.createElement("rect", {
    x: 135.92,
    y: 143.92,
    style: {
      fill: "#DB2B42"
    },
    width: 240,
    height: 96
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 135.92,
    y: 264,
    style: {
      fill: "#CCCCCC"
    },
    width: 112,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.92,
    y: 288,
    style: {
      fill: "#CCCCCC"
    },
    width: 112,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.92,
    y: 312,
    style: {
      fill: "#CCCCCC"
    },
    width: 112,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 264,
    style: {
      fill: "#CCCCCC"
    },
    width: 104,
    height: 56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserWebsite);
export default __webpack_public_path__ + "static/media/browser-website.605476d3dad3cf72e330e59cec3bce32.svg";
export { ForwardRef as ReactComponent };